export function HowItWorks() {
  return (
    <section className="info panel" aria-labelledby="how-it-works-heading">
      <h2 id="how-it-works-heading">Cómo funciona</h2>
      <p>
        Cada evento sintético pasa por el mismo Worker de Cloudflare que sirve esta demo: recepción,
        verificación de firma HMAC-SHA256 y timestamp, deduplicación por clave de idempotencia e
        identidad del payload contra D1, reintento solo de fallos transitorios, y resultado. Cada
        decisión queda registrada como un hallazgo con severidad, mensaje y sugerencia.
      </p>
      <div>
        <h3>Límites del Worker público</h3>
        <ul className="limits-list">
          <li>Máximo 20 solicitudes por minuto por origen (rate limit en D1).</li>
          <li>Cuerpo de solicitud limitado a 20&nbsp;KB.</li>
          <li>Solo se acepta el origen de esta demo (CORS controlado).</li>
          <li>Los registros en D1 caducan a los 7 días (TTL).</li>
          <li>Kill switch de operación para pausar el endpoint sin desplegar código.</li>
        </ul>
      </div>
      <div>
        <h3>Arquitectura</h3>
        <p>
          Cloudflare Pages sirve la interfaz; un Worker ejecuta la validación y persiste únicamente
          ejecuciones sintéticas en D1 con TTL. El motor de reglas es un módulo TypeScript puro
          compartido entre el navegador (tipos y pruebas) y el Worker, sin lógica de dominio
          duplicada.
        </p>
      </div>
      <div>
        <h3>Repositorio</h3>
        <p>
          Código, contratos JSON Schema, pruebas y decisiones en{' '}
          <a href="https://github.com/Aredex/webhook-reliability-playground">
            github.com/Aredex/webhook-reliability-playground
          </a>
          .
        </p>
      </div>
    </section>
  );
}
